import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Translate from '../Translate';
import Icons from '../../../configs/icon.config';
import formatBengaliNumber from '../../../utils/banglaNumber';

import './styles.scss';

interface CarouselFooterI {
  totalItem: number;
  currentItem: number;
  isEmpty: boolean;
  previous: () => void;
  next: () => void;
}

function CarouselFooter({
  totalItem,
  currentItem,
  isEmpty,
  previous,
  next,
}: CarouselFooterI) {
  const { t } = useTranslation();
  return (
    <div className="carousel-footer-wrapper">
      <div className="flex items-center justify-between carousel-footer">
        <div className="text-[12px] mt-1 flex bottom-4 left-10 md:bottom-8 md:left-10 w-[50%]">
          <div className="mr-2 mt-[5px]">{Icons.clock}</div>
          <div>
            {t('importantDocuments.show')}{' '}
            <Translate
              en={`${currentItem}`}
              bn={`${formatBengaliNumber(`${currentItem}`)}`}
            />
            /
            <Translate
              en={`${totalItem}`}
              bn={`${formatBengaliNumber(`${totalItem}`)}`}
            />
          </div>
        </div>
        <div className="buttons w-[50%]">
          <button
            disabled={isEmpty}
            className={`${
              isEmpty ? 'button-disabled' : 'button'
            } inline-flex items-center`}
            onClick={previous}
          >
            <span className="mr-2">
              <FaChevronUp />
            </span>
            {t('button.last')}
          </button>
          <button
            disabled={isEmpty}
            className={`${
              isEmpty ? 'button-disabled' : 'button'
            } inline-flex items-center`}
            onClick={next}
          >
            <span className="ml-6 mr-2">
              <FaChevronDown />
            </span>
            {t('button.next')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CarouselFooter;
